module.exports = __webpack_public_path__ + "img/sp-sort-button-down.f7e80cca.svg";